import { useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { QueryKeys } from '../queryKeys';
export const EMPTY_CLIENTS = [];
export const useClients = function useClients() {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.Clients
        ],
        queryFn: ()=>api.client.getAll(),
        enabled,
        refreshOnHookMount
    });
    return {
        clients: data !== null && data !== void 0 ? data : EMPTY_CLIENTS,
        isLoading,
        error,
        refresh
    };
};
